import { Box, IconButton, InputAdornment, Popover, TextField } from "@mui/material"
import React, { useContext, useEffect, useRef, useState } from "react"
import { userService } from "../../services/auth";
import NewButton from "../../components/NewButton";
import { UserTypeContext } from "../../context/userStatus";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ArrowUpNew } from "../../assets/images/icon/ArrowDownGreenNew";
import insightsProgressStyles from "../insightsV2/insightsClasses";
import { setUserObject } from "../../store/actions/userTypeAction";
dayjs.extend(customParseFormat);
const HolidayMode = ({
    setShowSnakbar,
    setSnakbarMsg,
    setMsgType,
    isDarkMode = false
}) => {
    let userValues = JSON.parse(localStorage.getItem("userValues"));
    const [startshowPicker, setstartShowPicker] = useState(false)
    const [endshowPicker, setendShowPicker] = useState(false)
    const { state: outcomeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const [buttonLoading, setButtonLoading] = useState(false)
    const [isFromExport, setIsFromExport] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [holidayModeOn, setHolidayModeOn] = React.useState(false);
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const handleChangeHolidayMode = () => {
        const token = localStorage.getItem("userDetails")
        setButtonLoading(true)
        userService.updateHolidayMode({
            "holidayMode": holidayModeOn ? "OFF" : startDate && endDate ? "ON" : "OFF",
            "holidayStartDate": startDate ? dayjs(startDate).format("MM-DD-YYYY") : null,
            "holidayEndDate": endDate ? dayjs(endDate).format("MM-DD-YYYY") : null
        }, token).then((data) => {
            const userId = {
                uid: outcomeState?.userId ? outcomeState?.userId : userValues?.uid,
            };
            userService
                .getUserById(userId)
                .then((data: any) => {
                    userTypeDispatch(
                        setUserObject({
                            ...data?.data,
                            showGoal: data?.showGoal,
                            userSubscriptionStatus: data.userSubscriptionStatus,
                            userAccountStatus: data?.userAccountStatus,
                            celebrationData: data?.celebrationData,
                            formatHolidayEndDate: data?.formatHolidayEndDate,
                            formatHolidayStartDate: data?.formatHolidayStartDate,
                            holidayMode: data?.holidayMode
                        })
                    );
                    localStorage.setItem("userValues", JSON.stringify(data?.data));
                    setButtonLoading(false)

                }).catch(() => {
                    setButtonLoading(false)
                })
        }).catch((err) => {
            setButtonLoading(false)

        })
    }

    useEffect(() => {
        console.log("outcomeState.userDetails.formatHolidayStartDate", outcomeState.userDetails);
        
        if (outcomeState.userDetails && outcomeState.userDetails.formatHolidayStartDate) {
            setStartDate(dayjs(outcomeState.userDetails.formatHolidayStartDate, "MM-DD-YYYY"))
        }
        if (outcomeState.userDetails && outcomeState.userDetails.formatHolidayEndDate) {
            setEndDate(dayjs(outcomeState.userDetails.formatHolidayEndDate, "MM-DD-YYYY"))
        }
        if (outcomeState.userDetails.formatHolidayEndDate && outcomeState.userDetails.formatHolidayStartDate && outcomeState.userDetails.holidayMode !== "OFF") {
            setHolidayModeOn(true)
        } else {
            setHolidayModeOn(false)

        }
    }, [outcomeState.userDetails])

    return <>
        <Box display={"flex"} alignItems={"flex-start"} flexDirection={"column"} gap={"24px"}>
            <Box display={"flex"} alignItems={"center"} gap={"24px"}>
                <DatePick name={"Start date"} disabledSelection={false} startDate={null} selectedDate={startDate} setSelectedDate={(date) => {
                    setStartDate(date)
                    if (dayjs(date) && endDate && dayjs(endDate).isBefore(date)) {
                        setEndDate(null)
                    }
                }} showpicker={startshowPicker} setShowPicker={(visible) => {
                    setstartShowPicker(visible)
                }}
                />
                <DatePick name={"End date"} disabledSelection={!startDate} startDate={startDate} selectedDate={endDate} setSelectedDate={setEndDate} showpicker={endshowPicker} setShowPicker={(visible) => {
                    setendShowPicker(visible)
                }}
                />
            </Box>
            <Box display={"flex"} alignItems={"center"} justifyContent={"flex-end"} width={"100%"} gap={"24px"}>
                <NewButton isLoadong={buttonLoading} buttonText={holidayModeOn ? "Turn off" : "Activate"} isDisabled={!startDate || !endDate} borderRadius={"20px !important"} padding="16px" extraSx={{
                    background: holidayModeOn ? "var(--color-border)" : "var(--color-new-main)",
                    border: "none",
                    width: "127px",
                    height: "40px",
                    marginBottom: "0px !important",
                    "&:hover": {
                        background: holidayModeOn ? "var(--color-border)" : "var(--color-new-main)"
                    },
                    "&.MuiButton-outlined": {
                        border: `none`,
                    },
                    "&.MuiButton-contained": {
                        border: `none`,
                    },
                    ...(isDarkMode && (!startDate || !endDate) ? {
                        "&.MuiButton-containedPrimary .MuiBox-root .MuiTypography-root": {
                            color: "var(--color-text-primary) !important",
                        },
                    } : {}),
                }} fontSize={`16px`} fontWeight={600} typographySx={{
                    color: "var(--color-text-primary)",
                    fontSize: "16px !important",
                    lineHeight: "16px !important",
                    fontWeight: `600 !important`,
                    letterSpacing: "2% important"
                }} onClick={() => {
                    handleChangeHolidayMode()
                }} /* onClick={outcomeState.restrictUser ? () => userTypeDispatch(setOpenSubscriptionModal(true)) : () => closeModal(true)} */ />
            </Box>
        </Box>
    </>
}

export default HolidayMode

const DatePick = ({
    name, selectedDate, disabledSelection, setSelectedDate, showpicker, setShowPicker, startDate
}) => {
    const classes = insightsProgressStyles()
    const [popupvisible, setpopupvisible] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };
    console.log("startDate", startDate);

    const selectRef = useRef(null);
    return <Box display={"flex"} /* flexDirection={"column"} */ gap={"8px"} alignItems={"center"}>
        <LocalizationProvider dateAdapter={AdapterDayjs} >
            <TextField
                value={selectedDate ? selectedDate.format("DD MMM YYYY") : ""}
                ref={selectRef}
                onClick={(event) => {
                    event.currentTarget.blur()
                    setShowPicker(true)
                    setAnchorEl(selectRef.current)
                }}
                placeholder={name}
                disabled={disabledSelection}
                onFocus={(event) => event.currentTarget.blur()}
                sx={{
                    width: "100%",
                    height: "51px",
                    "&.MuiTextField-root": {
                        marginBottom: "0px !important",
                    },
                    "& .MuiOutlinedInput-root": {
                        alignItems: "center",
                        color: "#19442E",
                        gap: "8px",
                        borderRadius: "16px !important",
                        border: "1px solid #F3F3F3",
                        background: "#FFF",
                        "& .MuiOutlinedInput-input": {
                            padding: "16px 12px !important",
                            color: "var(--color-text-primary) !important",
                            fontWeight: `600 !important`,
                            fontSize: "16px !important",
                            '&::placeholder': {
                                fontWeight: `600 !important`,
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                opacity: 1
                            },
                        },
                    },
                }}
            />
            {showpicker && (
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'left',
                    }}
                    sx={{
                        '& .MuiPaper-root': {
                            background: "#FFFFFF",
                            boxShadow: "0px 0px 64px 0px #190D1A1A",
                            borderRadius: "12px",
                            width: "312px"
                        }
                    }}
                >
                    <StaticDatePicker
                        value={selectedDate}
                        onChange={(newValue) => {
                            console.log("Selected date:", newValue);
                            setShowPicker(false)
                            setSelectedDate(newValue);
                        }}
                        displayStaticWrapperAs="desktop"
                        components={{
                            SwitchViewButton: (buttonProps) => (
                                <IconButton {...buttonProps}>
                                    <ArrowUpNew /> {/* Custom icon */}
                                </IconButton>
                            ),
                        }}
                        disablePast
                        componentsProps={{
                            actionBar: { sx: { display: "none" } }, // Hides the action toolbar
                        }}
                        shouldDisableDate={(date) => {
                            if (startDate) {
                                // Disable if date is same as or after startDate
                                return date.isSame(startDate, 'day') || date.isBefore(startDate, 'day');
                            }

                        }}
                        className={classes.calendarClassSetting}
                        inputFormat="DD MMM YYYY"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                sx={{
                                    width: "200px", // Set width to 200px
                                    "&.MuiTextField-root": {
                                        marginBottom: "0px !important",
                                    },

                                    "& .MuiOutlinedInput-root": {
                                        alignItems: "center",
                                        color: "#19442E",
                                        gap: "8px",
                                        borderRadius: "16px !important",
                                        border: "1px solid #F3F3F3",
                                        background: "#FFF",
                                        "& .MuiOutlinedInput-input": {
                                            padding: "16px 12px !important",
                                            color: "#19442E!important",
                                            '&::placeholder': {
                                                textTransform: "uppercase"
                                            },
                                        },
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {null}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        )}
                    />
                </Popover>

            )}

        </LocalizationProvider>
    </Box>
}
